import { render } from "./mainBoard.vue?vue&type=template&id=5e080907"
import script from "./mainBoard.vue?vue&type=script&lang=js"
export * from "./mainBoard.vue?vue&type=script&lang=js"

import "./mainBoard.vue?vue&type=style&index=0&id=5e080907&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__